const colorsRange = {
    'renda': {
        'default': [
            { min: 0, max: 1525, color: '#FB7574' },
            { min: 1525.01, max: 2713, color: '#FDBCBA' },
            { min: 2713.01, max: 4607, color: '#E6D0B9' },
            { min: 4607.01, max: 8150, color: '#FEDB37' },
            { min: 8150.01, max: 16186, color: '#FEF6B8' },
            { min: 16186.01, max: 28096, color: '#38963E' },
            { min: 28096.01, max: Infinity, color: '#1F5823' }
        ],
        'nr_salario_minimo_mensal_por_domicilio': [
            { min: 0, max: 2, color: '#ff9999' },
            { min: 2.01, max: 3, color: '#ff6666' },
            { min: 3.01, max: 5, color: '#ff3333' },
            { min: 5.01, max: 7, color: '#ff0000' },
            { min: 7.01, max: 10, color: '#cc0000' },
            { min: 10.01, max: 15, color: '#990000' },
            { min: 15.01, max: 20, color: '#9F0712' },
            { min: 20.01, max: Infinity, color: '#460809' },
        ],

        colors_options: [
            '#FEF2F2',
            '#FF6467',
            '#FFA2A2',
            '#FFC9C9',
            '#FFE2E2',
            '#460809',
            '#800000',
            '#82181A',
            '#990000',
            '#9F0712',
            '#C11007',
            '#E7180B',
            '#FB2C36',
            '#b35900',
            '#cc0000',
            '#ff0000',
            '#ff3333',
            '#ff6666',
            '#ff9999',
        ]
    },
    'consumo_valor': {
        'default': [
            { min: 0, max: 1525, color: '#ff9999' },
            { min: 1525.01, max: 2713, color: '#ff6666' },
            { min: 2713.01, max: 4607, color: '#ff3333' },
            { min: 4607.01, max: 8150, color: '#ff0000' },
            { min: 8150.01, max: 16186, color: '#cc0000' },
            { min: 16186.01, max: 28096, color: '#990000' },
            { min: 28096.01, max: Infinity, color: '#800000' }
        ],
        colors_options: [
            '#FEF2F2',
            '#FF6467',
            '#FFA2A2',
            '#FFC9C9',
            '#FFE2E2',
            '#460809',
            '#800000',
            '#82181A',
            '#990000',
            '#9F0712',
            '#C11007',
            '#E7180B',
            '#FB2C36',
            '#b35900',
            '#cc0000',
            '#ff0000',
            '#ff3333',
            '#ff6666',
            '#ff9999',
        ]
    },
    'consumo_porcentagem': {
        'default': [
            { min: 0, max: 5, color: '#ff9999' },
            { min: 5.01, max: 10, color: '#ff3333' },
            { min: 10.01, max: 20, color: '#ff0000' },
            { min: 20.01, max: 50, color: '#cc0000' },
            { min: 50.01, max: 60, color: '#990000' },
            { min: 60.01, max: Infinity, color: '#800000' },
        ],
        colors_options: [
            '#FEF2F2',
            '#FF6467',
            '#FFA2A2',
            '#FFC9C9',
            '#FFE2E2',
            '#460809',
            '#800000',
            '#82181A',
            '#990000',
            '#9F0712',
            '#C11007',
            '#E7180B',
            '#FB2C36',
            '#b35900',
            '#cc0000',
            '#ff0000',
            '#ff3333',
            '#ff6666',
            '#ff9999',
        ],
    },
    'populacao': {
        'default': [
            { min: 0, max: 100, color: '#ffcc99' },
            { min: 100.01, max: 200, color: '#ffb366' },
            { min: 200.01, max: 300, color: '#ff9933' },
            { min: 300.01, max: 400, color: '#ff8000' },
            { min: 400.01, max: 500, color: '#e67300' },
            { min: 500.01, max: 600, color: '#cc6600' },
            { min: 600.01, max: Infinity, color: '#b35900' }
        ],
        'nr_densidade_demografica_hab_km2': [
            { min: 0, max: 1000, color: '#FDB9BA' },
            { min: 1000.01, max: 5000, color: '#FC7778' },
            { min: 5000.01, max: 10000, color: '#FB282E' },
            { min: 10000.01, max: 15000, color: '#D1262C' },
            { min: 15000.01, max: 25000, color: '#A32226' },
            { min: 25001, max: Infinity, color: '#772122' },
        ],
        'tx_pessoas_domicilios': [
            { min: 0, max: 1, color: '#ffdf6e' },
            { min: 1.01, max: 1.5, color: '#D0872E' },
            { min: 1.51, max: 2, color: '#ff9800' },
            { min: 2.01, max: 2.5, color: '#e65100' },
            { min: 2.51, max: 3, color: '#733E0A' },
            { min: 3.01, max: 4, color: '#432004' },
            { min: 4.01, max: Infinity, color: '#432004' },
        ],

        'nr_populacao_0_4_anos_v01031': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_5_9_anos_v01032': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_10_14_anos_v01033': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_15_19_anos_v01034': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_20_24_anos_v01035': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_25_29_anos_v01036': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],

        // Grupos acima de 30 anos (seguem o padrão: 20, 40, 60, 80, 100, 120)
        'nr_populacao_30_39_anos_v01037': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 40, color: '#ffb366' },
            { min: 40.01, max: 60, color: '#ff9933' },
            { min: 60.01, max: 80, color: '#ff8000' },
            { min: 80.01, max: 100, color: '#e67300' },
            { min: 100.01, max: 120, color: '#cc6600' },
            { min: 120.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_40_49_anos_v01038': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 40, color: '#ffb366' },
            { min: 40.01, max: 60, color: '#ff9933' },
            { min: 60.01, max: 80, color: '#ff8000' },
            { min: 80.01, max: 100, color: '#e67300' },
            { min: 100.01, max: 120, color: '#cc6600' },
            { min: 120.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_50_59_anos_v01039': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 40, color: '#ffb366' },
            { min: 40.01, max: 60, color: '#ff9933' },
            { min: 60.01, max: 80, color: '#ff8000' },
            { min: 80.01, max: 100, color: '#e67300' },
            { min: 100.01, max: 120, color: '#cc6600' },
            { min: 120.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_60_69_anos_v01040': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 40, color: '#ffb366' },
            { min: 40.01, max: 60, color: '#ff9933' },
            { min: 60.01, max: 80, color: '#ff8000' },
            { min: 80.01, max: 100, color: '#e67300' },
            { min: 100.01, max: 120, color: '#cc6600' },
            { min: 120.01, max: Infinity, color: '#b35900' }
        ],
        'nr_populacao_70_anos_mais_v01041': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 40, color: '#ffb366' },
            { min: 40.01, max: 60, color: '#ff9933' },
            { min: 60.01, max: 80, color: '#ff8000' },
            { min: 80.01, max: 100, color: '#e67300' },
            { min: 100.01, max: 120, color: '#cc6600' },
            { min: 120.01, max: Infinity, color: '#b35900' }
        ],
        colors_options: [
            '#FEFCE8',
            '#FEF9C2',
            '#FFF085',
            '#FFDF20',
            '#FDC745',
            '#F0B13B',
            '#D0872E',
            '#A65F1B',
            '#894B0A',
            '#733E0A',
            '#432004',
            '#ffcc99',
            '#ffb366',
            '#ff9933',
            '#ff8000',
            '#e67300',
            '#cc6600',
            '#b35900'
        ]
    },
    'domicilios': {
        'default': [
            { min: 0, max: 100, color: '#ffcc99' },
            { min: 100.01, max: 200, color: '#ffb366' },
            { min: 200.01, max: 300, color: '#ff9933' },
            { min: 300.01, max: 400, color: '#ff8000' },
            { min: 400.01, max: 500, color: '#e67300' },
            { min: 500.01, max: 600, color: '#cc6600' },
            { min: 600.01, max: Infinity, color: '#b35900' }
        ],
        'domic_part_alugado_v008': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 40, color: '#ffb366' },
            { min: 40.01, max: 60, color: '#ff9933' },
            { min: 60.01, max: 80, color: '#ff8000' },
            { min: 80.01, max: 100, color: '#e67300' },
            { min: 100.01, max: 120, color: '#cc6600' },
            { min: 120.01, max: Infinity, color: '#b35900' }
        ],
        'domic_part_proprio_em_aquisicao_v007': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 60, color: '#ff8000' },
            { min: 60.01, max: 80, color: '#e67300' },
            { min: 80.01, max: 120, color: '#cc6600' },
            { min: 120.01, max: Infinity, color: '#b35900' }
        ],
        'domic_part_proprio_quitado_v006': [
            { min: 0, max: 50, color: '#ffcc99' },
            { min: 50.01, max: 100, color: '#ffb366' },
            { min: 100.01, max: 150, color: '#ff9933' },
            { min: 150.01, max: 200, color: '#ff8000' },
            { min: 200.01, max: 250, color: '#e67300' },
            { min: 250.01, max: 300, color: '#cc6600' },
            { min: 300.01, max: Infinity, color: '#b35900' }
        ],
        'domic_part_cedido_outro_v010': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],
        'domic_part_cedido_por_empregador_v009': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],
        'nr_domicilios_particulares_ocupados_v0007': [
            { min: 0, max: 100, color: '#ffcc99' },
            { min: 100.01, max: 200, color: '#ffb366' },
            { min: 200.01, max: 300, color: '#ff9933' },
            { min: 300.01, max: 400, color: '#ff8000' },
            { min: 400.01, max: 500, color: '#e67300' },
            { min: 500.01, max: 600, color: '#cc6600' },
            { min: 600.01, max: Infinity, color: '#b35900' }
        ],

        'domic_part_outra_condicao_v011': [
            { min: 0, max: 10, color: '#ffcc99' },
            { min: 10.01, max: 20, color: '#ffb366' },
            { min: 20.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],

        'nr_dom_part_perm_ocupados_apartamento_v00049': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 40, color: '#ffb366' },
            { min: 40.01, max: 60, color: '#ff9933' },
            { min: 60.01, max: 80, color: '#ff8000' },
            { min: 80.01, max: 100, color: '#e67300' },
            { min: 100.01, max: 120, color: '#cc6600' },
            { min: 120.01, max: Infinity, color: '#b35900' }
        ],

        'nr_dom_part_perm_ocupados_casa_v00047': [
            { min: 0, max: 60, color: '#ffcc99' },
            { min: 60.01, max: 100, color: '#ffb366' },
            { min: 100.01, max: 140, color: '#ff9933' },
            { min: 140.01, max: 180, color: '#ff8000' },
            { min: 180.01, max: 220, color: '#e67300' },
            { min: 220.01, max: 260, color: '#cc6600' },
            { min: 260.01, max: Infinity, color: '#b35900' }
        ],
        'nr_dom_part_perm_ocupados_vila_cond_v00048': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 30, color: '#ffb366' },
            { min: 30.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 80, color: '#cc6600' },
            { min: 80.01, max: Infinity, color: '#b35900' }
        ],


        'nr_domicilios_particulares_v0003': [
            { min: 0, max: 100, color: '#ffcc99' },
            { min: 100.01, max: 200, color: '#ffb366' },
            { min: 200.01, max: 300, color: '#ff9933' },
            { min: 300.01, max: 400, color: '#ff8000' },
            { min: 400.01, max: 500, color: '#e67300' },
            { min: 500.01, max: 600, color: '#cc6600' },
            { min: 600.01, max: Infinity, color: '#b35900' }
        ],

        'nr_domicilios_particulares_vagos': [
            { min: 0, max: 20, color: '#ffcc99' },
            { min: 20.01, max: 30, color: '#ffb366' },
            { min: 30.01, max: 40, color: '#ff9933' },
            { min: 40.01, max: 50, color: '#ff8000' },
            { min: 50.01, max: 60, color: '#e67300' },
            { min: 60.01, max: 70, color: '#cc6600' },
            { min: 70.01, max: Infinity, color: '#b35900' }
        ],

        'tx_indice_propriedade': [
            { min: 0, max: 30, color: '#FEF6B8' },
            { min: 30.01, max: 50, color: '#D2E8FF' },
            { min: 50.01, max: 65, color: '#74D0FF' },
            { min: 65.01, max: 80, color: '#1E77D1' },
            { min: 80.01, max: 100, color: '#341A49' },
        ],
        'taxa_domicilios_2010_2022': [
            { min: -Infinity, max: -0.01, color: '#fff9e6' }, // negative values: very pale yellow
            { min: 0, max: 20, color: '#fff3b0' },
            { min: 20.01, max: 40, color: '#ffe066' },
            { min: 40.01, max: 60, color: '#ffd43b' },
            { min: 60.01, max: 75, color: '#ffc107' },
            { min: 75.01, max: 90, color: '#ff9800' },
            { min: 90.01, max: 100, color: '#f57c00' },
            { min: 100.01, max: Infinity, color: '#b26a00' } // darkest amber for highest values
        ],
        'area_km2': [
            { min: 0, max: 1, color: '#ffcc99' },
            { min: 1.01, max: 2, color: '#ffb366' },
            { min: 2.01, max: 3, color: '#ff9933' },
            { min: 3.01, max: 4, color: '#ff8000' },
            { min: 4.01, max: 5, color: '#e67300' },
            { min: 5.01, max: 6, color: '#cc6600' },
            { min: 6.01, max: Infinity, color: '#b35900' }
        ],
        'indice_verticalizacao': [
            { min: 0, max: 9.99, color: '#FDF3B6' },
            { min: 10, max: 19.99, color: '#FFE378' },
            { min: 20, max: 39.99, color: '#FEC536' },
            { min: 40, max: 59.99, color: '#FDA333' },
            { min: 60, max: 79.99, color: '#F5892F' },
            { min: 80, max: 100, color: '#884031' },
        ],
        colors_options: [
            '#FEFCE8',
            '#FEF9C2',
            '#FFF085',
            '#FFDF20',
            '#FDC745',
            '#F0B13B',
            '#D0872E',
            '#A65F1B',
            '#894B0A',
            '#733E0A',
            '#432004',
            '#ffcc99',
            '#ffb366',
            '#ff9933',
            '#ff8000',
            '#e67300',
            '#cc6600',
            '#b35900'
        ]
    },
    'trabalhador': {
        'default': [
            { min: 0, max: 9999999999, color: '#2a2ad4' },
        ]
    },
    'dutovias': {
        'default': [
            { min: 0, max: 9999999999, color: '#704b31' },
        ]
    },
    'expansao_urbana': {
        'default': [
            { min: 1980, max: 1989, color: '#e0e0e0' },
            { min: 1990, max: 1995, color: '#bdbdbd' },
            { min: 1996, max: 2000, color: '#90a4ae' },
            { min: 2001, max: 2005, color: '#90a4ae' },
            { min: 2006, max: 2010, color: '#78909c' },
            { min: 2011, max: 2015, color: '#607d8b' },
            { min: 2016, max: 2020, color: '#546e7a' },
            { min: 2021, max: 2025, color: '#455a64' },
            { min: 2026, max: 2030, color: '#37474f' },
            { min: 2031, max: 2035, color: '#263238' },
        ],
        colors_options: [
            '#e0e0e0',
            '#bdbdbd',
            '#90a4ae',
            '#90a4ae',
            '#78909c',
            '#607d8b',
            '#546e7a',
            '#455a64',
            '#37474f',
            '#263238',
            '#F9FAFB',
            '#F3F4F6',
            '#E5E7EB',
            '#D1D5DC',
            '#99A1AF',
            '#6A7282',
            '#4A5565',
            '#364153',
            '#1E2939',
            '#101828',
            '#030712',
        ]
    },
    'area_preservacao': {
        'default': [
            { min: 0, max: 9999999999, color: '#28ac28' },
        ],
        colors_options: [
            '#28ac28',
            '#F0FDF4',
            '#DCFCE7',
            '#B9F8CF',
            '#7BF1A8',
            '#05DF72',
            '#31C950',
            '#2AA63E',
            '#178236',
            '#016630',
            '#0D542B',
            '#032E15'
        ]
    },
    'area_urbanizada': {
        'default': [
            { min: 0, max: 9999999999, color: '#b3b3b3' },
        ],
        colors_options: [
            '#e0e0e0',
            '#bdbdbd',
            '#90a4ae',
            '#90a4ae',
            '#78909c',
            '#607d8b',
            '#546e7a',
            '#455a64',
            '#37474f',
            '#263238',
            '#F9FAFB',
            '#F3F4F6',
            '#E5E7EB',
            '#D1D5DC',
            '#99A1AF',
            '#6A7282',
            '#4A5565',
            '#364153',
            '#1E2939',
            '#101828',
            '#030712',
        ]
    }
    , 'indicadores_municipio': {
        'default': [
            { min: 0, max: 9999999999, color: '#b3b3b3' },
        ],
        colors_options: [
            '#e0e0e0',
            '#bdbdbd',
            '#90a4ae',
            '#90a4ae',
            '#78909c',
            '#607d8b',
            '#546e7a',
            '#455a64',
            '#37474f',
            '#263238',
            '#F9FAFB',
            '#F3F4F6',
            '#E5E7EB',
            '#D1D5DC',
            '#99A1AF',
            '#6A7282',
            '#4A5565',
            '#364153',
            '#1E2939',
            '#101828',
            '#030712',
        ]
    },
    'indice_propriedade': {
        'tx_indice_propriedade': [
            { min: 0, max: 30, color: '#FEF6B8' },
            { min: 30.01, max: 50, color: '#D2E8FF' },
            { min: 50.01, max: 65, color: '#74D0FF' },
            { min: 65.01, max: 80, color: '#1E77D1' },
            { min: 80.01, max: 100, color: '#341A49' },
        ],
        'default': [
            { min: 0, max: 30, color: '#FEF6B8' },
            { min: 30.01, max: 50, color: '#D2E8FF' },
            { min: 50.01, max: 65, color: '#74D0FF' },
            { min: 65.01, max: 80, color: '#1E77D1' },
            { min: 80.01, max: 100, color: '#341A49' },
        ],
        colors_options: [
            '#e0e0e0',
            '#bdbdbd',
            '#90a4ae',
            '#90a4ae',
            '#78909c',
            '#607d8b',
            '#546e7a',
            '#455a64',
            '#37474f',
            '#263238',
            '#F9FAFB',
            '#F3F4F6',
            '#E5E7EB',
            '#D1D5DC',
            '#99A1AF',
            '#6A7282',
            '#4A5565',
            '#364153',
            '#1E2939',
            '#101828',
            '#030712',
        ]
    },
    'vazios_urbanos': {
        'default': [
            { min: 0, max: 9999999999, color: '#535050' },
        ],
        colors_options: [
            '#e0e0e0',
            '#bdbdbd',
            '#90a4ae',
            '#90a4ae',
            '#78909c',
            '#607d8b',
            '#546e7a',
            '#455a64',
            '#37474f',
            '#263238',
            '#F9FAFB',
            '#F3F4F6',
            '#E5E7EB',
            '#D1D5DC',
            '#99A1AF',
            '#6A7282',
            '#4A5565',
            '#364153',
            '#1E2939',
            '#101828',
            '#030712',
        ]
    },
}

export default {
    colorsRange
}
